import { customWorkQsStructure } from "../components/work_queues/pages/custom/globalWorkQStructure";
import { groupByState } from "./misc";
import { filterWorkQByTeams, getItemFromStorage, isDeveloper } from "./script";
import { workQFunctions } from "./workQ";

/** Cache payer-type *policy status* option lists — hot path for WorkQ VerificationBox (avoids repeated storage + array rebuild per cell). */
let _payerTypeStatusOptsWinSettingsRef = null;
let _payerTypeStatusOptsLsSettingsStr = null;
const _payerTypeStatusOptsCache = {
    liability: undefined,
    pip: undefined,
    mp: undefined,
    um: undefined,
    mm: undefined,
};

function invalidatePayerTypeStatusPolicyOptionsCache() {
    _payerTypeStatusOptsCache.liability = undefined;
    _payerTypeStatusOptsCache.pip = undefined;
    _payerTypeStatusOptsCache.mp = undefined;
    _payerTypeStatusOptsCache.um = undefined;
    _payerTypeStatusOptsCache.mm = undefined;
}

function ensurePayerTypeStatusPolicyOptionsCacheFresh() {
    if (typeof window !== "undefined" && window.systemSettings) {
        if (window.systemSettings !== _payerTypeStatusOptsWinSettingsRef) {
            _payerTypeStatusOptsWinSettingsRef = window.systemSettings;
            invalidatePayerTypeStatusPolicyOptionsCache();
        }
        return;
    }
    let s = null;
    try {
        s = localStorage.getItem("settings");
    } catch {
        s = null;
    }
    if (s !== _payerTypeStatusOptsLsSettingsStr) {
        _payerTypeStatusOptsLsSettingsStr = s;
        invalidatePayerTypeStatusPolicyOptionsCache();
    }
}

export const caseTypeOptions = () => {
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.case_types) {
        systemSettings.case_types.forEach(element => {
            data.push({
                label: element.name,
                value: element.id,
                isDisabled: element.active == 0 ? 1 : 0,
                ...element
            })
        });

        return data
    }

    return null
}



export const caseSourcesOptions = () => {
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.case_sources) {
        systemSettings.case_sources.forEach(element => {
            data.push({
                // label: element.full_name ? element.full_name : element.name,
                label: element.name,
                value: element.id,
                isDisabled: element.active == 0 ? 1 : 0,
                ...element
            })
        });

        return data.sort((a, b) => a.label.localeCompare(b.label))
    }

    return null
}

export const attorneyStatusesOptions = () => {
    const systemSettings = getItemFromStorage('settings')
    let data = []
    
    if (systemSettings && systemSettings.attorney_statuses) {
        systemSettings.attorney_statuses.filter(item => item.show_in_attorney_status).forEach(element => {
            data.push({
                label: element.name,
                value: element.id,
                isDisabled: element.active == 0 ? 1 : 0,
                ...element
            })
        });

        return data
    }

    return null
}

export const caseStatusesOptions = () => {
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.case_statuses) {
        systemSettings.case_statuses.forEach(element => {
            data.push({
                label: element.name,
                value: element.id,
                isDisabled: element.active == 0 ? 1 : 0,
                ...element
            })
        });

        return data
    }

    return null
}


export const stateOfPIPsOptions = () => {
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.state_of_pips) {        
        systemSettings.state_of_pips.forEach(element => {
            data.push({
                label: element.name,
                value: element.id,
                isDisabled: element.active == 0 ? 1 : 0,
                ...element
            })
        });

        return data
    }

    return null
}

export const countiesOptions = () => {
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.counties) {        
        systemSettings.counties.forEach(element => {
            data.push({
                label: element.name,
                value: element.id,
                isDisabled: element.active == 0 ? 1 : 0,
                ...element
            })
        });

        return data
    }

    return null
}

export const countiesOptionsWorkQFilters = (stateCode) => {
    const systemSettings = getItemFromStorage('settings')
    let data = []
    const stateFilter = stateCode ? stateCode.toString().trim() : null
    if (systemSettings && systemSettings.counties) {        
        systemSettings.counties.forEach(element => {
            if (stateFilter && element.state !== stateFilter) return
            data.push({
                label: element.name + ' (' + element.state + ')',
                value: element.id,
                isDisabled: element.active == 0 ? 1 : 0,
                ...element
            })
        });

        return data
    }

    return null
}

export const countiesOptionsGrouped = () => {
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.counties) {  
        const groupedByState = groupByState(systemSettings.counties); 
    
        Object.keys(groupedByState).forEach(state => {
            data.push({
                label: state,
                options: groupedByState[state]
            })
        });

        return data
    }

    return null
}

export const practicesOptions = () => {
    const systemSettings = getItemFromStorage('settings')
    let data = []
 
    if (systemSettings && systemSettings.practices) {        
        systemSettings.practices.forEach(element => {
            data.push({
                label: element.name,
                value: element.id,
                data: element,
                isDisabled: element.active == 0 ? 1 : 0,
                ...element
            })
        });

        return data
    }

    

    return null
}

export const practiceSpecificLocationOptions = (practiceId) => {
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.practices) {     
        let selectedpractice = systemSettings.practices.find(item => item.id == practiceId)

        if (selectedpractice) {
            selectedpractice.locations.forEach(element => {
                data.push({
                    label: element.code, //{/* display_name */}
                    value: element.id,
                    data: element,
                    isDisabled: element.active == 0 ? 1 : 0,
                    ...element
                })
            })
            return data
        }
        
    }

    return null
}

export const practicesLocationsGroupedOptions = () => {
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.practices) {        
        systemSettings.practices.forEach(element => {
            let loc = []
            element.locations.forEach(item => {
                loc.push({
                    label: item.code,
                    value: item.id,
                    isDisabled: item.active == 0 ? 1 : 0,
                    ...item
                })
            })
            data.push({
                label: element.name,
                options: loc,
                isDisabled: element.active == 0 ? 1 : 0,
            })
        });

        return data
    }

    return null
}


export const documentsTypes = () => {
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.document_types) {        
        systemSettings.document_types.forEach(element => {
            data.push({
                label: element.name,
                value: element.id,
                data: element,
                isDisabled: element.active == 0 ? 1 : 0,
                ...element
            })
        });

        return data
    }

    return null
}

export function getStatusIDFromMappingSettings(name) {
    const systemSettings = getItemFromStorage('settings')
    if (systemSettings && systemSettings.mappings) {
        return systemSettings.mappings[name]
    }

    return null
}

export const attorneyStatusOptionsPayerTypes = () => {
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.payer_types) {    
        let mappingsId = getStatusIDFromMappingSettings('attorney') 
        if (mappingsId) {
            let liabiltyStatus = systemSettings.payer_types.find(item => item.id == mappingsId) // Attorney id == 5

            if (liabiltyStatus) {
                liabiltyStatus.payer_statuses.forEach(element => {
                    data.push({
                        label: element.name,
                        value: element.id,
                        isDisabled: element.active == 0 ? 1 : 0,
                        ...element
                    })
                });
    
                return data
            }
        }
    }

    return null
}

export const attorneyLegalStatusOptions = () => {
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.legal_statuses) {        
        systemSettings.legal_statuses.forEach(element => {
            data.push({
                label: element.name,
                value: element.id,
                isDisabled: element.active == 0 ? 1 : 0,
                ...element
            })
        });

        return data
    }

    return null
}

export const liabilityPolicyLimitsOptions = () => {
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.liability_policy_limits) {        
        systemSettings.liability_policy_limits.forEach(element => {
            data.push({
                label: element.name,
                value: element.id,
                isDisabled: element.active == 0 ? 1 : 0,
                ...element
            })
        });

        return data
    }

    return null
}


export const liabilityPolicyStatusOptionsPayerTypes = () => {
    ensurePayerTypeStatusPolicyOptionsCacheFresh();
    if (_payerTypeStatusOptsCache.liability !== undefined) {
        return _payerTypeStatusOptsCache.liability;
    }
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.payer_types) {    
        let mappingsId = getStatusIDFromMappingSettings('liability') 
        if (mappingsId) {
            let liabiltyStatus = systemSettings.payer_types.find(item => item.id == mappingsId) // 3rd Party Liability id == 6

            if (liabiltyStatus) {
                liabiltyStatus.payer_statuses.forEach(element => {
                    data.push({
                        label: element.name,
                        value: element.id,
                        isDisabled: element.active == 0 ? 1 : 0,
                        ...element
                    })
                });
    
                _payerTypeStatusOptsCache.liability = data;
                return data
            }
        }
    }

    _payerTypeStatusOptsCache.liability = null;
    return null
}

export const medPayPolicyLimitsOptions = () => {
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.med_pay_policy_limits) {        
        systemSettings.med_pay_policy_limits.forEach(element => {
            data.push({
                label: element.name,
                value: element.id,
                isDisabled: element.active == 0 ? 1 : 0,
                ...element
            })
        });

        return data
    }

    return null
}

export const medPayPIPPolicyStatusOptionsPayerTypes = () => {
    ensurePayerTypeStatusPolicyOptionsCacheFresh();
    if (_payerTypeStatusOptsCache.pip !== undefined) {
        return _payerTypeStatusOptsCache.pip;
    }
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.payer_types) {    
        let mappingsId = getStatusIDFromMappingSettings('pip') 
        if (mappingsId) {
            let pipStatus = systemSettings.payer_types.find(item => item.id == mappingsId) // PIP id == 3

            if (pipStatus) {
                pipStatus.payer_statuses.forEach(element => {
                    data.push({
                        label: element.name,
                        value: element.id,
                        isDisabled: element.active == 0 ? 1 : 0,
                        ...element
                    })
                });
    
                _payerTypeStatusOptsCache.pip = data;
                return data
            }
        }        
    }
    _payerTypeStatusOptsCache.pip = null;
    return null
}



export const medPayMPPolicyStatusOptionsPayerTypes = () => {
    ensurePayerTypeStatusPolicyOptionsCacheFresh();
    if (_payerTypeStatusOptsCache.mp !== undefined) {
        return _payerTypeStatusOptsCache.mp;
    }
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.payer_types) {    
        let mappingsId = getStatusIDFromMappingSettings('mp') 
        if (mappingsId) {
            let mpStatus = systemSettings.payer_types.find(item => item.id == 4) // MP id == 4

            if (mpStatus) {
                mpStatus.payer_statuses.forEach(element => {
                    data.push({
                        label: element.name,
                        value: element.id,
                        isDisabled: element.active == 0 ? 1 : 0,
                        ...element
                    })
                });
    
                _payerTypeStatusOptsCache.mp = data;
                return data
            }
        }
        
    }

    _payerTypeStatusOptsCache.mp = null;
    return null
}

export const umPolicyLimitsOptions = () => {
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.um_policy_limits) {        
        systemSettings.um_policy_limits.forEach(element => {
            data.push({
                label: element.name,
                value: element.id,
                isDisabled: element.active == 0 ? 1 : 0,
                ...element
            })
        });

        return data
    }

    return null
}

export const umPolicyStatusOptionsPayerTypes = () => {
    ensurePayerTypeStatusPolicyOptionsCacheFresh();
    if (_payerTypeStatusOptsCache.um !== undefined) {
        return _payerTypeStatusOptsCache.um;
    }
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.payer_types) {    
        let mappingsId = getStatusIDFromMappingSettings('um') 
        if (mappingsId) {
            let umStatus = systemSettings.payer_types.find(item => item.id == mappingsId) // UM id == 7

            if (umStatus) {
                umStatus.payer_statuses.forEach(element => {
                    data.push({
                        label: element.name,
                        value: element.id,
                        isDisabled: element.active == 0 ? 1 : 0,
                        ...element
                    })
                });
    
                _payerTypeStatusOptsCache.um = data;
                return data
            }
        }
        
    }

    _payerTypeStatusOptsCache.um = null;
    return null
}

export const majorMedPolicyStatusOptionsPayerTypes = () => {
    ensurePayerTypeStatusPolicyOptionsCacheFresh();
    if (_payerTypeStatusOptsCache.mm !== undefined) {
        return _payerTypeStatusOptsCache.mm;
    }
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.payer_types) {    

        let mappingsId = getStatusIDFromMappingSettings('mm')        
        if (mappingsId) {
            let mpStatus = systemSettings.payer_types.find(item => item.id == mappingsId) 

            if (mpStatus) {
                mpStatus.payer_statuses.forEach(element => {
                    data.push({
                        label: element.name,
                        value: element.id,
                        isDisabled: element.active == 0 ? 1 : 0,
                        ...element
                    })
                });

                _payerTypeStatusOptsCache.mm = data;
                return data
            }
        }

        _payerTypeStatusOptsCache.mm = data;
        return data
    }

    _payerTypeStatusOptsCache.mm = null;
    return null
}
export const carrierTypeOptionById = (id) => {
    const found = getItemFromStorage('settings')?.carrier_types?.find((t) => t.id == id)
    if (!found) {
        return null
    }

    return {
        label: found.name,
        value: found.id,
        data: found,
        isDisabled: found.active == 0 ? 1 : 0,
        ...found,
    }
}

export const carrierTypesOptions = () => {
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.carrier_types) {        
        systemSettings.carrier_types.forEach(element => {
            data.push({
                label: element.name,
                value: element.id,
                data: element,
                isDisabled: element.active == 0 ? 1 : 0,
                ...element
            })
        });

        return data
    }

    return null
}

export const atpProvidersOptions = () => {
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.providers) {        
        systemSettings.providers.forEach(element => {
            data.push({
                // label: `${element.first_name} ${element.last_name}`,
                label: element.description,
                value: element.id,
                data: element,
                isDisabled: element.active == 0 ? 1 : 0,
                ...element
            })
        });

        return data
    }

    return null
}

export const workerCompsATPPolicyStatusOptionsPayerTypes = () => {
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.payer_types) {    

        let mappingsId = getStatusIDFromMappingSettings('wc_atp')        
        if (mappingsId) {
            let mpStatus = systemSettings.payer_types.find(item => item.id == mappingsId) 

            if (mpStatus) {
                mpStatus.payer_statuses.forEach(element => {
                    data.push({
                        label: element.name,
                        value: element.id,
                        isDisabled: element.active == 0 ? 1 : 0,
                        ...element
                    })
                });

                return data
            }
        }

        return data
    }

    return null
}
export const workerCompsATPAndAttorneyPolicyStatusOptionsPayerTypes = () => {
    return workerCompsATPPolicyStatusOptionsPayerTypes()
}


export const selfpayStatusOptionsPayerTypes = () => {
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.payer_types) {    
        let mappingsId = getStatusIDFromMappingSettings('selfpay') 
        if (mappingsId) {
            let liabiltyStatus = systemSettings.payer_types.find(item => item.id == mappingsId) // Self Pay id == 11

            if (liabiltyStatus) {
                liabiltyStatus.payer_statuses.forEach(element => {
                    data.push({
                        label: element.name,
                        value: element.id,
                        isDisabled: element.active == 0 ? 1 : 0,
                        ...element
                    })
                });
    
                return data
            }
        }
    }

    return null
}
export const selfpayCHUSAStatusOptionsPayerTypes = () => {
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.payer_types) {    
        //comment until mappins is available
        let mappingsId = getStatusIDFromMappingSettings('chusa') 
        // let mappingsId = 13
        if (mappingsId) {
            let liabiltyStatus = systemSettings.payer_types.find(item => item.id == mappingsId) // CHUSA id == 13

            if (liabiltyStatus) {
                liabiltyStatus.payer_statuses.forEach(element => {
                    data.push({
                        label: element.name,
                        value: element.id,
                        isDisabled: element.active == 0 ? 1 : 0,
                        ...element
                    })
                });
    
                return data
            }
        }
    }

    return null
}

export const noteTypesOptions = () => {
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.note_types) {        
        systemSettings.note_types.forEach(element => {
            data.push({
                label: element.name,
                value: element.id,
                isDisabled: element.active == 0 ? 1 : 0,
                ...element
            })
        });

        return data
    }

    return null
}
export const notePriorityOptions = () => {
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.note_action_priorities) {        


        for (const [key, value] of Object.entries(systemSettings.note_action_priorities)) {               
            data.push({
                label: key,
                value: key,
                ...value
            })
        }

        return data
    }

    return null
}
export const noteAsignTypesOptions = () => {
    const systemSettings = getItemFromStorage('settings')

    if (systemSettings && systemSettings.note_assignee_types) {
        let data = []
        for (const [key, value] of Object.entries(systemSettings.note_assignee_types)) {               
            data.push({
                label: value,
                value: key
            })
        } 

        return data
    }

    return null

}


export const noteTeamsOptions = () => {
    const systemSettings = getItemFromStorage('settings')

    let data = []
    if (systemSettings && systemSettings.teams) {
        const isTeamActive = (team) => !(team.active == 0 || team.active === false)

        systemSettings.teams.forEach(element => {
            if (!isTeamActive(element)) {
                return
            }
            data.push({
                label: element.name,
                value: element.id,
                ...element
            })
            if (element.children) {
                element.children.forEach(child => {
                    if (!isTeamActive(child)) {
                        return
                    }
                    data.push({
                        label: `- ${child.name}`,
                        value: child.id,
                        ...child
                    })
                })
            }
        });

        return data
    }

    return null

}

export const teamsOptions = () => {
    const systemSettings = getItemFromStorage('settings')
    if (systemSettings && systemSettings.teams) {
        return systemSettings.teams
    }
    return null
}

export const noteActionsOptions = () => {
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.note_actions) {        
        systemSettings.note_actions.forEach(element => {
            data.push({
                label: element.name,
                value: element.id,
                isDisabled: element.active == 0 ? 1 : 0,
                ...element
            })
        });

        return data
    }

    return null
}


export const outsideClinicOptions = () => {
    const systemSettings = getItemFromStorage('settings')
    let options = []
    if (systemSettings && systemSettings.outside_companies) {      
        systemSettings.outside_companies.forEach(element => {
            if (element.locations) {               
                element.locations.forEach(item => {
                    options.push({
                        label: element.name + ' - ' + item.name,
                        value: item.id,
                        isDisabled: element.active == 0 ? 1 : 0,
                        ...element
                    })
                })
            }
        }); 
        return options
    }
    return null
}

export const insideClinicOptions = () => {
    const systemSettings = getItemFromStorage('settings')
    let options = []
    if (systemSettings && systemSettings.practices) {   
        let data = []     
        systemSettings.practices.forEach(element => {
            if (element.locations) {
                data = [...data, ...element.locations]
            }
        });
        data.forEach(item => {
            options.push({
                label: item.code, //{/* display_name */}
                value: item.id,
                isDisabled: item.active == 0 ? 1 : 0,
                ...item
            })
        })

        return options
    }

    return null
}


export const getSmsTemplates = () => {
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.sms_templates) {        
        systemSettings.sms_templates.forEach(element => {
            data.push({
                label: element.name,
                value: element.id,
                isDisabled: element.active == 0 ? 1 : 0,
                ...element
            })
        });

        return data
    }

    return null
}

export const getMailTemplates = () => {
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.mail_templates) {        
        systemSettings.mail_templates.forEach(element => {
            data.push({
                label: element.name,
                value: element.id,
                isDisabled: element.active == 0 ? 1 : 0,
                ...element
            })
        });

        return data
    }
    return null
}


export const departmentsOptions = () => {
    const systemSettings = getItemFromStorage('settings')
    if (systemSettings && systemSettings.departments) {        
        return systemSettings.departments
    }
    return null
}


export function returnCptBaseOnId(id) {
    const systemSettings = getItemFromStorage('settings')
    if (systemSettings && systemSettings.cpts) {
        let cpt = systemSettings.cpts.find(item => item.id == id)
        return cpt
    }
    return null
}

export function cptOptions() {
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.cpts) {
        systemSettings.cpts.forEach(element => {
            if (element.active == 0 || element.active === false) {
                return
            }
            const parts = [element.code, element.area, element.name].filter(Boolean)
            data.push({
                ...element,
                label: element.code,
                value: element.id,
                complexLabel: parts.join(' - '),
            })
        })
        return data
    }
    return null
}

export function returnLocationSOSFromId(id) {
    const systemSettings = getItemFromStorage('settings')
    if (systemSettings && systemSettings.outside_companies) {
        let locations = []
        
        systemSettings.outside_companies.forEach(comp => {
            comp.locations.forEach(loc => {
                locations.push({
                    ...loc,
                    companyName: comp.name
                })
            })
        })
      
        let location = locations.find(item => item.id == id)
        return location
    }

    return null
}

const customWorkQBySlug = new Map(customWorkQsStructure.map((item) => [item.slug, item]))

/**
 * Overlay frontend custom template onto an API row so work_queue_groups ids still resolve.
 * Preserves id, parent_id, slug from API.
 */
function applyCustomWorkQTemplate(apiItem, template) {
    const { id: _tId, parent_id: _tParent, slug: _tSlug, ...fromTemplate } = template
    return {
        ...apiItem,
        ...fromTemplate,
        id: apiItem.id,
        parent_id: apiItem.parent_id,
        slug: apiItem.slug,
        slug_url: apiItem?.slug?.toLowerCase().split(' ').join('-'),
    }
}

/**
 * API work_queues merged with frontend customWorkQsStructure (canonical menu names, apiSlug, type).
 * Rows that exist in both keep backend id/parent_id/slug so group membership (e.g. work_queues: [44,45,46,47]) works.
 * Custom templates apply only when the slug exists in settings work_queues; frontend-only template rows are not shown.
 * @param {object} systemSettings
 * @param {object} user
 * @param {{ excludeHiddenFromMenu?: boolean }} options
 */
function mergeWorkQueuesWithCustom(systemSettings, user, options = {}) {
    const { excludeHiddenFromMenu = false } = options
    const custom_qs = Array.isArray(systemSettings.custom_qs) ? systemSettings.custom_qs : []

    let rows = systemSettings.work_queues
    if (excludeHiddenFromMenu) {
        rows = rows.filter((item) => !item.hide_in_menu)
    }

    const workQSlugs = rows
        .filter((item) => {
            if (customWorkQBySlug.has(item.slug)) {
                return true
            }
            return (
                !item.complex_filtering ||
                (item.complex_filtering && !custom_qs.includes(item.slug))
            )
        })
        .filter((item) => (isDeveloper() ? true : filterWorkQByTeams(item, user)))
        .map((item) => {
            const template = customWorkQBySlug.get(item.slug)
            if (template) {
                return applyCustomWorkQTemplate(item, template)
            }
            return {
                ...item,
                slug_url: item?.slug?.toLowerCase().split(' ').join('-'),
            }
        })

    return workQSlugs
}

export function retrieveAllWorkQs() {
    const systemSettings = getItemFromStorage('settings')
    const user = getItemFromStorage('user')
    if (systemSettings && systemSettings.work_queues) {
        return mergeWorkQueuesWithCustom(systemSettings, user, { excludeHiddenFromMenu: false })
    }
    return null
}


export function retrieveAllWorkQsCleaned() {
    const systemSettings = getItemFromStorage('settings')
    const user = getItemFromStorage('user')
    if (systemSettings && systemSettings.work_queues) {           
        let workQSlugs = systemSettings.work_queues.filter(item => isDeveloper() ? true : filterWorkQByTeams(item, user)).map(item => {
            return {
                ...item,
                slug_url: item?.slug?.toLowerCase().split(' ').join('-')
            }
        })
        
        return workQSlugs
    }
    return null
}


export function retrieveAllWorkQsAsOptions() {
    const systemSettings = getItemFromStorage('settings')
    const user = getItemFromStorage('user')
    if (systemSettings && systemSettings.work_queues) {   

       
        let workQSlugs = retrieveAllWorkQsCleaned().map(item => {
            return {
                label: item.name,
                value: item.id,
                ...item,
                slug_url: item?.slug?.toLowerCase().split(' ').join('-')
            }
        })

   
  
        return workQSlugs
    }
    return null
}

export function retrieveAllWorkQsGrouped() {
    const systemSettings = getItemFromStorage('settings')
    const user = getItemFromStorage('user')
    if (systemSettings && systemSettings.work_queues && systemSettings.work_queue_groups) {
        const finalList = mergeWorkQueuesWithCustom(systemSettings, user, { excludeHiddenFromMenu: true })
        return workQFunctions.workQListGrouped(finalList, systemSettings.work_queue_groups)
    }
    return null
}

const LIEN_MENU_GROUP_NAME = /lien/i

/**
 * True when the queue is in a menu group whose name contains "Lien",
 * or it is a child of a queue in that group.
 */
export function isLienRelatedWorkQ(workq) {
    if (!workq || workq.id == null) {
        return false
    }
    const groups = retrieveAllWorkQsGrouped()
    if (!groups) {
        return false
    }
    const lienWorkQIds = new Set()
    groups.forEach((group) => {
        if (!LIEN_MENU_GROUP_NAME.test(group?.name || '')) {
            return
        }
        ;(group.workQs || []).forEach((item) => {
            if (item?.id != null) {
                lienWorkQIds.add(String(item.id))
            }
        })
    })
    if (lienWorkQIds.has(String(workq.id))) {
        return true
    }
    if (workq.parent_id != null && lienWorkQIds.has(String(workq.parent_id))) {
        return true
    }
    return false
}

export function retrieveSpecificWorkQ(slug) {
    if (retrieveAllWorkQs()) {
        let item = retrieveAllWorkQs().find(item => item.slug == slug)
        if (item) {
            return item
        }
        return null
    }
    return null
}

export function retrieveSpecificWorkQCleaned(slug) {
    if (retrieveAllWorkQsCleaned()) {
        let item = retrieveAllWorkQsCleaned().find(item => item.slug == slug)
        if (item) {
            return item
        }
        return null
    }
    return null
}

export function retrieveTransportaionsData() {
    const systemSettings = getItemFromStorage('settings')
    if (systemSettings && systemSettings.transportation_settings) {        
        return systemSettings.transportation_settings
    }

    return null
}

export function retrievePayerTypes() {
    const systemSettings = getItemFromStorage('settings')
    
    let data = []  
    if (systemSettings && systemSettings.payer_types) {        
        systemSettings.payer_types.forEach(element => {
            data.push({
                label: element.name,
                value: element.id,
                ...element,
                case_types: element.case_types,
                payer_statuses: element.payer_statuses,
                manual_selection: !element.manual_selection
            })
        });

        return data
    }

    return null
}

export function retrievePayerStatuses() {
    const systemSettings = getItemFromStorage('settings')
    
    let data = []  
    if (systemSettings && systemSettings.payer_statuses) {        
        systemSettings.payer_statuses.forEach(element => {
            data.push({
                label: element.name,
                value: element.id,
                ...element,
                case_types: element.case_types,
                payer_statuses: element.payer_statuses,
                manual_selection: !element.manual_selection
            })
        });

        return data
    }

    return null
}

export function retrieveAllPayerStatuses() {
    const systemSettings = getItemFromStorage('settings')
    
    let data = []  
    if (systemSettings && systemSettings.payer_types) {        
        systemSettings.payer_types.forEach(element => {
            if (element && element.payer_statuses) {
                element.payer_statuses.forEach(stat => {
                    data.push({
                        label: stat.name,
                        value: stat.id,
                        ...stat
                    })
                })
            }            
        });

        return data
    }

    return null
}

export function retrievePayerTypesWithoutManualSelection() {
    const systemSettings = getItemFromStorage('settings')
    
    let data = []  
    if (systemSettings && systemSettings.payer_types) {        
        systemSettings.payer_types.forEach(element => {
            data.push({
                label: element.name,
                value: element.id,
                ...element
            })
        });

        return data
    }

    return null
}

export function attorneyStatusUnattached() {
    const systemSettings = getItemFromStorage('settings')
    
    let data = []  
    if (systemSettings && systemSettings.attorney_statuses) {        
        systemSettings.attorney_statuses.forEach(element => {
            // no_atty_reason => show_in_no_atty_reason
            if (element.show_in_no_atty_reason) {
                data.push({
                    label: element.name,
                    value: element.id,
                    isDisabled: element.active == 0 ? 1 : 0,
                    ...element
                })
            }
        });

        return data
    }

    return null
}

/**
 * Resolve an attorney status option by id from the correct list(s).
 * When a managing attorney exists, prefer show_in_attorney_status options but fall back
 * to show_in_no_atty_reason (e.g. first attorney seeded from case no_attorney_reason).
 */
export function resolveAttorneyStatusOption(id, hasManagingAttorney = true) {
    if (id == null || id === '') {
        return null
    }

    const primary = hasManagingAttorney ? attorneyStatusesOptions() : attorneyStatusUnattached()
    const item = primary?.find((option) => option.value == id)
    if (item) {
        return item
    }

    const secondary = hasManagingAttorney ? attorneyStatusUnattached() : attorneyStatusesOptions()
    return secondary?.find((option) => option.value == id) ?? null
}


export function selfPaySettings() {
    const systemSettings = getItemFromStorage('settings')
    if (systemSettings && systemSettings.selfpay_settings) {        
        return systemSettings.selfpay_settings
    }

    return null
}

export function treatmentStatusesOptions(ignoreDisabled) {
    const systemSettings = getItemFromStorage('settings')
    
    let data = []  

    if (systemSettings && systemSettings.treatment_statuses) {        
        systemSettings.treatment_statuses.forEach(element => {

            let item = {
                label: element.name,
                value: element.id,
                isDisabled: element.active == 0 ? 1 : 0,
                ...element
            }

            if (ignoreDisabled) {
                delete item.isDisabled
            }
            data.push(item)
        });

        return data
    }

    return null
}




export function practicePatientStatusesOptions(ignoreDisabled, injectStatus) {
    const systemSettings = getItemFromStorage('settings')
    let data = []  
    if (injectStatus) {
        data.push(injectStatus)
    }
    if (systemSettings && systemSettings.practice_patient_statuses) {        
        systemSettings.practice_patient_statuses.forEach(element => {

            let item = {
                label: element.name,
                value: element.id,
                isDisabled: element.active == 0 ? 1 : 0,
                ...element
            }

            if (ignoreDisabled) {
                delete item.isDisabled
            }
            data.push(item)
        });

        return data
    }
    return null
}

export function MRQStatusesOptions(showAll) {
    const systemSettings = getItemFromStorage('settings')
    
    let data = []  
    if (systemSettings && systemSettings.medical_record_statuses) {        
        systemSettings.medical_record_statuses.forEach(element => {

            let obj = {
                label: element.name,
                value: element.id,
                manual_selection: !element.is_manual_selection,
                ...element,
                isDisabled: element.active == 0 ? 1 : 0,
            }
            if (showAll) {
                delete obj.manual_selection
                delete obj.isDisabled
            }
            data.push(obj)
        });

        

        return data
    }

    return null
}


export function patientRelationsOptions() {
    const systemSettings = getItemFromStorage('settings')
    
    let data = []  
    if (systemSettings && systemSettings.patient_relations) {        
        systemSettings.patient_relations.forEach(element => {
            data.push({
                label: element.name,
                value: element.id,
                ...element
            })
        });

        return data
    }

    return null
}

// Resolves a stored guardian_relationship to the matching option value.
// Legacy records may store the relationship label (e.g. "Mother") instead of
// the id. Match by value first, then fall back to label/name (case-insensitive).
// Returns the stored value as-is when no option matches so callers can still
// surface what was saved.
export function resolvePatientRelationValue(stored) {
    if (stored === null || stored === undefined || stored === '') return null

    const options = patientRelationsOptions() || []
    if (!options.length) return stored

    const byValue = options.find(o => o.value == stored)
    if (byValue) return byValue.value

    const storedStr = String(stored).toLowerCase()
    const byLabel = options.find(o =>
        (o.label != null && String(o.label).toLowerCase() === storedStr) ||
        (o.name != null && String(o.name).toLowerCase() === storedStr)
    )
    return byLabel ? byLabel.value : stored
}



export function ngPatientStatusesOptionsFiltered(practiceId) {
    const systemSettings = getItemFromStorage('settings')
    
    let data = []  
    if (systemSettings && systemSettings.ng_patient_statuses) {        
        systemSettings.ng_patient_statuses.filter(item => item.practice_id == practiceId).forEach(element => {
            data.push({
                label: element.name,
                value: element.id,
                ...element
            })
        });

        return data
    }

    return null
}

export function allNgPatientStatusesOptions() {
    const systemSettings = getItemFromStorage('settings')
    
    let data = []  
    if (systemSettings && systemSettings.ng_patient_statuses) {        
        systemSettings.ng_patient_statuses.forEach(element => {
            data.push({
                label: element.name,
                value: element.id,
                ...element
            })
        });

        return data
    }

    return null
}

export function getCaseLevelOptions() {
    const systemSettings = getItemFromStorage('settings')
    
    let data = []  
    if (systemSettings && systemSettings.case_levels) {        
        systemSettings.case_levels.forEach(element => {
            data.push({
                label: element.name,
                value: element.id,
                ...element
            })
        });

        return data
    }

    return null
}

export function getPreferedContactsOptions() {
    const systemSettings = getItemFromStorage('settings')
    
    let data = []  
    if (systemSettings && systemSettings.prefered_contacts) {        
        systemSettings.prefered_contacts.forEach(element => {
            data.push({
                label: element.name,
                value: element.name,
                ...element
            })
        });

        return data
    }

    return null
}


/**
 * Name suffix dropdown options from NextGen list-items (type name_suffix).
 * Option value is NextGen id (suffixId). If the patient has a legacy free-text
 * suffix that is not in the synced list, include it as a temporary option.
 *
 * @param {{ suffix?: string|null, suffix_id?: string|null }|null|undefined} patient
 */
export function getNameSuffixOptions(patient) {
    const systemSettings = getItemFromStorage('settings')
    let data = []

    if (systemSettings && systemSettings.name_suffixes) {
        systemSettings.name_suffixes.forEach(element => {
            if (!element.nextgen_id) {
                return
            }
            data.push({
                label: element.name,
                value: element.nextgen_id,
                ...element
            })
        })
    }

    const currentSuffix = String(patient?.suffix ?? '').trim()
    const currentSuffixId = patient?.suffix_id ?? null

    if (currentSuffix) {
        const matchedById = currentSuffixId
            ? data.some(option => String(option.value) === String(currentSuffixId))
            : false
        const matchedByName = data.some(option => String(option.label) === currentSuffix)

        if (!matchedById && !matchedByName) {
            data.unshift({
                label: currentSuffix,
                value: currentSuffixId || currentSuffix,
                legacy: true,
            })
        }
    }

    return data.length ? data : null
}





export const procoDocsDocumentTypesOptions = (exclude) => {
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.proco_docs_document_types) {        
        systemSettings.proco_docs_document_types.forEach(element => {

            if (exclude) {      
                if (!element.use_for) {
                    data.push({
                        label: element.name,
                        value: element.id,
                        item: element,
                        ...element
                    })
                }

            } else {
                data.push({
                    label: element.name,
                    value: element.id,
                    item: element,
                    ...element
                })
            }
            
        });

        return data
    }

    return null
}


export function splitFlagsBasedOnName(detailsFlags) {
    if (detailsFlags) {
        const systemSettings = getItemFromStorage('settings')
        const flags = []
        for (const [key, value] of Object.entries(detailsFlags)) { 
            
            if (value) {
                flags.push(key)
            }
        }
        if (systemSettings && systemSettings.case_flags) {

            let settingsFlags = systemSettings.case_flags.map(item => {

                let items = []
                item.filters.forEach(elem => {
                    if (flags.includes(elem.key)) {
                        items.push(elem)
                    }
                })

                return {
                    ...item,
                    filters: items
                }
            })

            return settingsFlags

        }
    }

    return null
}

export const messageTemplatesOptions = () => {
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.message_templates) {        
        data = systemSettings.message_templates

        return data
    }

    return null
}




export const frontendOptions = () => {
    const systemSettings = getItemFromStorage('settings')
    let data = {}
    if (systemSettings && systemSettings.frontend_options) {        
        for (const [key, value] of Object.entries(systemSettings.frontend_options)) {  
            data[key] = value
        }

        return data
    }

    return null
}

/**
 * Default patient-referrals list filter from `frontend_options.DEFAULT_REFERRAL_STATUS_FILTER`
 * (array of status values). Each value is resolved against `REFERRAL_STATUS` for label/display;
 * unknown values still pass through as `{ value, label }` so filters and selects work.
 */
export function getDefaultReferralStatusFilter() {
    const fo = frontendOptions()
    const defaultValues = fo?.DEFAULT_REFERRAL_STATUS_FILTER ?? fo?.default_referral_status_filter
    if (!Array.isArray(defaultValues) || defaultValues.length === 0) {
        return []
    }
    const opts = fo?.REFERRAL_STATUS
    const seen = new Set()
    const out = []
    for (const raw of defaultValues) {
        if (raw == null || raw === '') {
            continue
        }
        const found = opts?.find((o) => o.value == raw || String(o.value) === String(raw))
        if (found) {
            if (seen.has(found.value)) {
                continue
            }
            seen.add(found.value)
            out.push({ label: found.label, value: found.value })
        } else {
            if (seen.has(raw)) {
                continue
            }
            seen.add(raw)
            out.push({ label: String(raw), value: raw })
        }
    }
    return out
}

export function shouldShowFieldUpdateLoader() {
    const opts = frontendOptions()
    const raw = opts?.SHOW_FIELD_UPDATE_LOADER ?? opts?.show_field_update_loader
    return raw === true || raw === 1 || raw === '1'
}

export function modelTypesSystem() {
    const systemSettings = getItemFromStorage('settings')
    
    if (systemSettings && systemSettings.class_names) {
        let data = []
        for (const [key, value] of Object.entries(systemSettings.class_names)) {               
            data.push({
                label: value,
                value: key
            })
        } 

        return data
    }

    return null
}

export function getNegotiatorType() {
    const systemSettings = getItemFromStorage('settings') 
    if (systemSettings && systemSettings.negotiator_types) {
        let data = []
        for (const [key, value] of Object.entries(systemSettings.negotiator_types)) {               
            data.push({
                label: value,
                value: key
            })
        } 

        return data
    }

    return null
}

export function evaluationTypesOptions() {
    const systemSettings = getItemFromStorage('settings')
    
    let data = []  
    if (systemSettings && systemSettings.evaluation_types) {        
        systemSettings.evaluation_types.forEach(element => {
            data.push({
                label: element,
                value: element,
            })
        });

        return data
    }

    return null
}


export function preOpTestsOptions() {
    const systemSettings = getItemFromStorage('settings')
    
    let data = []  
    if (systemSettings && systemSettings.pre_op_tests) {        
        systemSettings.pre_op_tests.forEach(element => {
            data.push({
                label: element.label,
                value: element.field,
            })
        });

        return data
    }

    return null
}

export const isCaseTypeOptions = () => {
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.is_case_options) {        
        systemSettings.is_case_options.forEach(element => {
            data.push({
                label: element.label,
                value: element.value,
            })
        });

        return data
    }

    return null
}

export const nextgenAppointmentEventsOptions = () => {
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.nextgen_appointment_events) {        
        systemSettings.nextgen_appointment_events.forEach(element => {
            data.push({
                label: element.name,
                value: element.id,
                isDisabled: element.active == 0 ? 1 : 0,
                ...element
            })
        });

        return data
    }

    return null
}



export function gdqStatusOptions() {
    const systemSettings = getItemFromStorage('settings')
    
    let data = []  
    if (systemSettings && systemSettings.global_discharge_statuses) {        
        systemSettings.global_discharge_statuses.forEach(element => {
            data.push({
                label: element.name,
                value: element.id,
                isDisabled: element.active == 0 ? 1 : 0, //|| element.is_other_status
                ...element
            })
        });

        return data
    }

    return null
}

export function verificationStatusOptions() {
    const systemSettings = getItemFromStorage('settings')
    
    let data = []  
    if (systemSettings && systemSettings.frontend_options.VERIFICATION_STATUS) {        
        systemSettings.frontend_options.VERIFICATION_STATUS.forEach(element => {
            data.push({                
                ...element
            })
        });

        return data
    }

    return null
}

export const retriveAllCaseFlags = (filters) => {
    const systemSettings = getItemFromStorage('settings')
    if (systemSettings && systemSettings.case_flags) {
        return systemSettings.case_flags
        
    }
    return null
}

export const stateOptions = () => {
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.states) {        
        for (const [key, value] of Object.entries(systemSettings.states)) {               
            data.push({
                label: key,
                value: value,
            })
        }

        return data
    }

    return null
}

export const appointmentDepartmentsOptions = () => {
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.appointment_departments) {        
        for (const [key, value] of Object.entries(systemSettings.appointment_departments)) {               
            data.push({
                label: value,
                value: key,
            })
        }

        return data
    }

    return null
}

export const transfersStatusOptions = () => {
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.transfer_statuses) {        
        for (const [key, value] of Object.entries(systemSettings.transfer_statuses)) {               
            data.push({
                label: key,
                value: value,
            })
        }

        return data
    }

    return null
}


export const AICALocationsOptions = () => {
    const systemSettings = getItemFromStorage('settings')
    if (systemSettings && systemSettings.practices) {
        let aica = systemSettings.practices.find(item => item.name == 'AICA')
        if (aica) {
            let arr = []

            aica.locations.forEach(element => {
                arr.push({
                    label: element.code, //{/* display_name */}
                    value: element.id,
                })
            })
            return arr
        }
        
    }
    return null
}

export function isTestCaseForLien(activeCase) {
    const systemSettings = getItemFromStorage('settings')
    if (activeCase && systemSettings && systemSettings.lien_settings) {
        if (systemSettings.lien_settings.lient_test_mode) { // check if test mode is true
            // if (systemSettings.lien_settings.lien_test_case_ids.includes(activeCase?.case?.id)) { // check case id
                return true
            // }
        }
    }

    return false
}



export const mrqRecordUploadViaOptions = () => {
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.mrq_record_upload_via) {        
        for (const [key, value] of Object.entries(systemSettings.mrq_record_upload_via)) {               
            data.push({
                label: key,
                value: value,
            })
        }

        return data
    }

    return null
}

export const nextgenDiagnosticServicesOptions = () => {
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.nextgen_diagnostic_services_filter) {        
        for (const [key, value] of Object.entries(systemSettings.nextgen_diagnostic_services_filter)) {               
            data.push({
                label: value,
                value: value,
            })
        }
        return data
    }

    return null
}

export const nextgenDiagnosticServicesOptionsSimple = () => {
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.nextgen_diagnostic_services_filter) {        
        return systemSettings.nextgen_diagnostic_services_filter
    }
    return null
}

export const nextgenReferralServicesOptions = () => {
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.nextgen_referral_services_filter) {        
        for (const [key, value] of Object.entries(systemSettings.nextgen_referral_services_filter)) {               
            data.push({
                label: value,
                value: value,
            })
        }
        return data
    }

    return null
}

export const nextgenReferralServicesOptionsSimple = () => {
    const systemSettings = getItemFromStorage('settings')
    let data = []
    if (systemSettings && systemSettings.nextgen_referral_services_filter) {        
        return systemSettings.nextgen_referral_services_filter
    }
    return null
}


export const workQueueRefreshApiTimeout = () => {
    const systemSettings = getItemFromStorage('settings')
    if (systemSettings && systemSettings.workq_refresh_time) {
        // workq_refresh_time is stored in minutes; convert minutes → ms
        return systemSettings.workq_refresh_time * 60 * 1000
    }

    // default: 1 minute
    return 60_000
}